// Also serialized into the blocking theme script; keep this function self-contained.
export function setThemeColor(color: string): void {
	let meta = document.querySelector<HTMLMetaElement>(
		'meta[name="theme-color"]',
	);
	if (!meta) {
		meta = document.createElement('meta');
		meta.name = 'theme-color';
		document.head.append(meta);
	}
	meta.content = color;
}
